function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import { Provider } from 'react-redux';
import store from "./store/index";
import App from "./App";
import t from "./scripts/i18n"; // import ModuleSettings from './pages/ModuleSettings';

import { getDictionary, setLanguage } from "./store/actions/app";
export var meta = {
  name: 'Contacts',
  pathSegment: 'contacts'
};
export var config = {
  hideHeader: false,
  hideMainWrap: false,
  hideFooter: true,
  requireAuthentication: true,
  requireAuthorization: true
};
export var getMenu = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(access, language) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch(getDictionary(language));

          case 2:
            _context.next = 4;
            return store.dispatch(setLanguage(language));

          case 4:
            if (access) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            return _context.abrupt("return", [{
              text: t('module_name_contacts'),
              pathSegment: ''
            }]);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getMenu(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var AppWithStoreProvider = function AppWithStoreProvider(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(App, _objectSpread({}, props)));
}; // export const Settings = (props) => {
//   return React.createElement(Provider, {store: store}, React.createElement(ModuleSettings, {...props}));
// };


export default AppWithStoreProvider;